import { create } from 'zustand'
import type { PDFDocumentProxy } from 'pdfjs-dist'

interface PageSize {
  width: number
  height: number
}

interface PdfDocStoreState {
  docs: Record<string, PDFDocumentProxy | null>
  pageSizes: Record<string, PageSize[]>
  setDoc: (documentId: string, doc: PDFDocumentProxy | null) => void
  getDoc: (documentId: string) => PDFDocumentProxy | null
  setPageSizes: (documentId: string, sizes: PageSize[]) => void
  getPageSize: (documentId: string, pageIndex: number) => PageSize | null
}

export const usePdfDocStore = create<PdfDocStoreState>((set, get) => ({
  docs: {},
  pageSizes: {},
  setDoc: (documentId, doc) =>
    set((s) => ({ docs: { ...s.docs, [documentId]: doc } })),
  getDoc: (documentId) => get().docs[documentId] ?? null,
  setPageSizes: (documentId, sizes) =>
    set((s) => ({ pageSizes: { ...s.pageSizes, [documentId]: sizes } })),
  getPageSize: (documentId, pageIndex) =>
    get().pageSizes[documentId]?.[pageIndex] ?? null,
}))
